module.exports = __webpack_public_path__ + "img/yrykb.935aebe2.png";